/* eslint-disable */ // cant worry about it rn

/*
    !!! WARNING !!!
    Below, you will find the most digusting React code known to man.
    I apologize to anyone who has to work with or even just see this atrocity.
*/

import { MouseEventHandler, useEffect, useState } from "react";
import PORGLogo from "../Components/PORGLogo";
import { Course, sendPostReq, User } from "../Scripts/misc";
import "../Styles/courseListPage.css";
import CourseCard from "../Components/CourseListPage/CourseCard";
import { Modal } from "bootstrap";
import Footer from "../Components/Footer";
import SignedUpCourseCard from "../Components/CourseListPage/SignedUpCourseCard";
import SignedInSection from "../Components/CourseListPage/SignedInSection";

interface Props {
  /*userData: User | undefined,*/
  courses: Course[];
  token: string;
}

function CourseListPage({ courses, token }: Props) {
  let [selectedCourse, setSelectedCourse] = useState<Course>(courses[0]);

  let alrSignedModal: Modal | undefined = undefined;

  useEffect(() => {
    alrSignedModal = new Modal(
      document.getElementById("alrSignedModal") as HTMLElement
    );
  }, [selectedCourse]);

  const signUp = async (course: Course) => {
    let res = await sendPostReq("/api/signInToCourse", {
      token: token,
      course: course.id,
    });

    switch (res.data) {
      case "alreadySignedIn":
        alrSignedModal?.show();
        break;
      default:
        window.location.reload();
    }
  };

  // I HATE ALL OF THIS
  // I HATE IT SO MUCH
  useEffect(() => {
    document.addEventListener("click", function (event) {
      var isClickInside = document
        .querySelector(".dropdown")
        ?.contains(event.target as Node);
      if (!isClickInside) {
        (document.querySelector(".menu") as HTMLElement).style.display = "none";
        (document.querySelector(".caret") as HTMLElement).style.transform =
          "rotate(0deg)";
      }
    });

    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }, []);

  let signedUpCourses = courses.filter((c) => c.currentUserSignedIn);

  return (
    <div className="row centerAlign">
      <div className="container-fluid mt-5" style={{ marginLeft: "2vw" }}>
        <div className="filter-block">
            <h3>
              <b>Kroužky</b>
            </h3>
        </div>

        <div className="course-container">
          <div
            className={
              signedUpCourses.length
                ? "course-card-container row signed"
                : "course-card-container row"
            } /*style={signedUpCourses.length ? { width: "75vw", marginLeft: "0vw"} : {}}*/
          >
            {courses.map((course) => {
              return <CourseCard course={course} signUp={signUp} />;
            })}
          </div>

          <SignedInSection signedUpCourses={signedUpCourses} token={token} />
        </div>

        {/*signed in modal*/}
        <div
          className="modal fade"
          id="alrSignedModal"
          tabIndex={-1}
          aria-labelledby="waitingStatusLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="waitingStatusLabel">
                  Err
                </h5>
                <button type="button" className="close" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                Na tento kroužek jste už přihlášeni
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Rozumím
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CourseListPage;
